import adapter from './adapter'
import { collectionGetters } from  '@/store/collection'

const { getCollection } = collectionGetters(adapter)

export default {
    getCollection,
    isFetching: (state, getters) => id => adapter.getIds(getters.getCollection).indexOf(id) !== -1,
    getRequest: (state, getters) => id => adapter.getOne(id, getters.getCollection).request,
}